<template>
    <a-col :span="24">
      <a-row style="padding: 12px 0px 12px 0px; text-align: left;">
        <a-button type="primary" @click="showAddUser">添加用户</a-button>
      </a-row>

      <a-row>
        <h3>共有{{total}}个用户</h3>
      </a-row>

      <a-row>
        <h3>您的邀请码为：{{invite_code}}</h3>
      </a-row>

      <a-row style="padding: 12px 0px 12px 0px; text-align: left;">
        <a-button type="primary" @click="showStats">分析</a-button>
      </a-row>

      <div id="stats" style="width: 1200px; height: 500px; display: none;"></div>

      <a-row class="content-container">
        <a-row v-for="(user_data, index) in list" :key="index" class="content-item">
          <a-card style="border: 0px;" :bodyStyle="{padding: '10px', textAlign: 'left'}">
            <a-row>
              <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" style="margin-bottom: 4px;">
                <h3><a-icon type="user"/>&nbsp;{{user_data.account}}</h3>
              </a-col>
              <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" style="margin-bottom: 4px;">
                <h3><a-icon type="phone"/>&nbsp;{{user_data.mobile}}</h3>
              </a-col>
              <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" style="margin-bottom: 8px;">
                <b>注册时间：</b>{{user_data.created | timeChange}}
              </a-col>
              <div style="position: absolute; right: 0px; text-align: right;">
                <a style="color: #1890ff" @click="changeUserStatus(index)">{{user_data.status | statusChange}}</a>
              </div>
            </a-row>
            <a-row v-for="(service, order) in user_data.product_str" :key="order" style="margin-bottom: 4px; border-top: 1px solid #e1e4e8;">
              <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="margin-bottom: 4px;">
                <b>服务名称：</b>{{service.name}}
              </a-col>
              <!--a-col :xs="24" :sm="24" :md="4" :lg="6" :xl="6" style="margin-bottom: 4px;">
                <b>订阅套餐：</b>{{service.version_name}}
              </a-col -->
              <a-col :xs="24" :sm="24" :md="7" :lg="6" :xl="6" style="margin-bottom: 4px;">
                <b>生效时间：</b>{{service.start | timeChange}}
              </a-col>
              <!-- a-col :xs="24" :sm="24" :md="7" :lg="6" :xl="6" style="margin-bottom: 4px;">
                <b>到期时间：</b>{{service.expired | timeChange}}
              </a-col-->
              <div style="position: absolute; right: 0px; text-align: right;">
                <a style="color: #1890ff" @click="">更改</a>
              </div>
            </a-row>
          </a-card>
        </a-row>
      </a-row>

      <a-row v-if="list.length > 0" style="margin-top: 12px;">
        <a-button @click="loadMore">加载更多</a-button>
      </a-row>

      <a-row v-else="">
        <span>没有用户，请添加用户。</span>
      </a-row>
      
      <a-modal v-model="add_user" title="添加用户" :footer="null" :width="modalWidth" @cancel="resetAddUser">
        <edit-agent :price_table="price_table" @change="editChange"/>
      </a-modal>
    </a-col>
</template>

<script>
import EditAgent from './EditAgent.vue';

export default {
  name: 'Agent',
  data() {
    return {
      tab: 'agent',
      form: this.$form.createForm(this),
      type: '',
      postdata: {},
      list: [],
      add_user: false,
      price_table: [],
      spend: [],
      spend_all: 0.0,
      refresh: 0,
      page: 0, 
      modalWidth: "98%",
      invite_code: "",
      total: 0,
      line: {}
    }
  },
  components: {
    EditAgent
  },
  filters: {
    timeChange: function (value) {
      if (!value) {
        return "";
      }
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;

      let d = date.getDate();
      d = d < 10 ? "0" + d : d;

      let h = date.getHours();
      h = h < 10 ? "0" + h : h;

      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;

      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;

      return y + "-" + MM + "-" + d + " " + h + ":" + m;
    },
    statusChange: function (value) {
      if (value == 1) {
        return "禁用";
      } else {
        return "恢复";
      }
    }
  },
  mounted() {
  },
  methods: {
    showAddUser: function() {
      let postdata = {
        task: "GET_SERVICE_PRICE",
      }
      let that = this;
      that.post("price", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.price_table = data.data;
            that.add_user = !that.add_user;
          }
        }).catch(function (e) {
      });
    },
    showStats: function() {
      var myChart = this.echarts.init(document.getElementById('stats'));
      myChart.setOption({
        title: {
          text: ''
        },
        tooltip: {},
        xAxis: {
          type: 'category',
          data: this.line.date
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          type: 'line',
          data: this.line.value,
          smooth: true
        }]
      });
      document.getElementById('stats').style.display = "block";
    },
    resetAddUser: function() {
      this.add_user = !this.add_user;
    },
    editChange: function() {
    },
    changeUserStatus: function(index) {
      let status = this.list[index].status;
      let postdata = {
        uid: this.list[index].agent_key,
        task: "CHANGE_USER_STATUS"
      }
      let that = this;
      that.post("agent", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.$set(that.list[index], 'status', status == 1 ? 0:1);
          } else {
            that.$message.error("修改失败");
          }
        }).catch(function (e) {
          console.log(e);
          that.$message.error("修改失败");
      });
    },
    loadMore: function() {
      let postdata = {
        task: "AGENT_USER_LIST",
        from: this.page * 15,
        to: (this.page + 1) * 15
      }
      let that = this;
      that.post("agent", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            if (data.data.length == 0) {
              that.$message.success("没有更多数据了");
            } else {
              for(let i = 0; i < data.data.length; i++) {
                that.list.push(data.data[i]);
              }
              that.page += 1;
            }
          }
        }).catch(function (e) {
      });
    }
  },
  created() {
    let postdata = {
      task: "AGENT_USER_LIST",
      from: this.page * 15,
      to: (this.page + 1) * 15
    }
    let that = this;
    that.post("agent", postdata)
      .then(function(data) {
        if (data.ret == 200) {
          that.list = data.data;
          that.invite_code = data.invite_code;
          that.total = data.total;
          that.line = data.stats;
          that.page += 1;
        }
      }).catch(function (e) {
    });

    let deviceWidth = document.body.clientWidth
    if (deviceWidth >= 576) {
      this.modalWidth = "570px"; 
    }
  }
}
</script>

<style scoped>
  .content-container {
    border-bottom: 1px solid #e1e4e8;
    border-left: 1px solid #e1e4e8;
    border-right: 1px solid #e1e4e8;
  }
  .content-item {
    border-top: 1px solid #e1e4e8;
  }
</style>

<!-- 
modification of predefined style shouldn't be scoped and should be placed 
in a separate <style> tag. 
--> 
<style>
  div /deep/ .ant-modal-header {
    padding: 12px;
  }

  div /deep/.ant-modal-body {
    padding: 12px;
  }
</style>
